var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingBar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4625 40.6658L39.6987 36.8282C36.2378 41.1238 30.9344 43.8824 25 43.8824C21.6409 43.8824 18.4955 42.9968 15.7573 41.4496L12.7646 46.7835C16.3782 48.8193 20.5517 49.9797 25 49.9797C32.8685 49.9797 39.8819 46.3356 44.4727 40.6556L44.4625 40.6658Z",
    fill: "#0072F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingBar);
export default __webpack_public_path__ + "static/media/loading_bar.c6c5b1c0cd11332917726f17862cc447.svg";
export { ForwardRef as ReactComponent };